/* tslint:disable */
import { Injectable } from '@angular/core';
import { Profile } from '../../models/Profile';
import { KanvasUser } from '../../models/KanvasUser';
import { Email } from '../../models/Email';
import { Services } from '../../models/Services';
import { Player } from '../../models/Player';
import { Address } from '../../models/Address';
import { Image } from '../../models/Image';
import { QuickArt } from '../../models/QuickArt';
import { Video } from '../../models/Video';
import { Audio } from '../../models/Audio';
import { Library } from '../../models/Library';
import { Feed } from '../../models/Feed';
import { Schedule } from '../../models/Schedule';
import { Screen } from '../../models/Screen';
import { Tutorial } from '../../models/Tutorial';
import { Statistic } from '../../models/Statistic';
import { Log } from '../../models/Log';
import { InvitationCode } from '../../models/InvitationCode';
import { Tag } from '../../models/Tag';
import { ChatMessage } from '../../models/ChatMessage';
import { ChatRoom } from '../../models/ChatRoom';
import { LimitedTimeOffer } from '../../models/LimitedTimeOffer';
import { OfferCode } from '../../models/OfferCode';
import { Container } from '../../models/Container';
import { PlayerGroup } from '../../models/PlayerGroup';
import { ScreenCategory } from '../../models/ScreenCategory';
import { CategoryRotation } from '../../models/CategoryRotation';
import { ScheduleTimeframe } from '../../models/ScheduleTimeframe';
import { ScheduleRotation } from '../../models/ScheduleRotation';
import { PlayerSerial } from '../../models/PlayerSerial';
import { RotationItem } from '../../models/RotationItem';
import { Kalipso } from '../../models/Kalipso';
import { ScreenLayout } from '../../models/ScreenLayout';
import { LayoutPanel } from '../../models/LayoutPanel';
import { Migration } from '../../models/Migration';
import { PlayerVersion } from '../../models/PlayerVersion';
import { Forecast } from '../../models/Forecast';
import { PlayerCommandLog } from '../../models/PlayerCommandLog';

export interface Models { [name: string]: any }

@Injectable()
export class SDKModels {

  private models: Models = {
    Profile: Profile,
    KanvasUser: KanvasUser,
    Email: Email,
    Services: Services,
    Player: Player,
    Address: Address,
    Image: Image,
    QuickArt: QuickArt,
    Video: Video,
    Audio: Audio,
    Library: Library,
    Feed: Feed,
    Schedule: Schedule,
    Screen: Screen,
    Tutorial: Tutorial,
    Statistic: Statistic,
    Log: Log,
    InvitationCode: InvitationCode,
    Tag: Tag,
    ChatMessage: ChatMessage,
    ChatRoom: ChatRoom,
    LimitedTimeOffer: LimitedTimeOffer,
    OfferCode: OfferCode,
    Container: Container,
    PlayerGroup: PlayerGroup,
    ScreenCategory: ScreenCategory,
    CategoryRotation: CategoryRotation,
    ScheduleTimeframe: ScheduleTimeframe,
    ScheduleRotation: ScheduleRotation,
    PlayerSerial: PlayerSerial,
    RotationItem: RotationItem,
    Kalipso: Kalipso,
    ScreenLayout: ScreenLayout,
    LayoutPanel: LayoutPanel,
    Migration: Migration,
    PlayerVersion: PlayerVersion,
    Forecast: Forecast,
    PlayerCommandLog: PlayerCommandLog,
    
  };

  public get(modelName: string): any {
    return this.models[modelName];
  }

  public getAll(): Models {
    return this.models;
  }

  public getModelNames(): string[] {
    return Object.keys(this.models);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/services/custom/SDKModels.ts